<template>
  <!-- MODAL OVERLAY — Teleport al body para que position: fixed funcione siempre -->
  <Teleport to="body">
    <div v-if="visible" class="cpm-overlay" @click.self="cerrar">
      <transition name="cpm-slide" appear>
        <div class="cpm-modal" role="dialog" aria-modal="true">

          <!-- HEADER DEL MODAL -->
          <div class="cpm-header">
            <div class="cpm-header-info">
              <div class="cpm-avatar">
                <img src="@/assets/logo/extragas-logo.png" alt="">
              </div>
              <div class="cpm-header-text">
                <strong>Consulta tu Pedido</strong>
                <small>Asistente · en línea</small>
              </div>
            </div>

            <div class="cpm-header-actions">
              <button
                type="button"
                class="cpm-icon-btn cpm-close"
                @click="cerrar"
                title="Cerrar"
              >
                <Icon icon="mdi:close" />
              </button>
            </div>
          </div>

          <!-- CUERPO — EL CHAT DE CONSULTA -->
          <div class="cpm-body">
            <ConsultaPedidoChat />
          </div>
        </div>
      </transition>
    </div>
  </Teleport>
</template>

<script>
import { Icon } from "@iconify/vue";
import ConsultaPedidoChat from "@/components/ConsultaPedidoChat.vue";

export default {
  name: "ConsultaPedidoModal",
  components: { Icon, ConsultaPedidoChat },
  props: {
    value: { type: Boolean, default: false }
  },
  emits: ["input", "update:value", "update:modelValue"],
  computed: {
    visible() {
      return this.value;
    }
  },
  watch: {
    visible(nuevo) {
      const bodyScroll = document.getElementById('body-scroll');
      if (nuevo) {
        document.body.style.overflow = 'hidden';
        if (bodyScroll) bodyScroll.style.overflow = 'hidden';
        window.addEventListener('keydown', this.onKeydown);
      } else {
        document.body.style.overflow = '';
        if (bodyScroll) bodyScroll.style.overflow = '';
        window.removeEventListener('keydown', this.onKeydown);
      }
    }
  },
  beforeUnmount() {
    document.body.style.overflow = '';
    const bodyScroll = document.getElementById('body-scroll');
    if (bodyScroll) bodyScroll.style.overflow = '';
    window.removeEventListener('keydown', this.onKeydown);
  },
  beforeDestroy() {
    document.body.style.overflow = '';
    const bodyScroll = document.getElementById('body-scroll');
    if (bodyScroll) bodyScroll.style.overflow = '';
    window.removeEventListener('keydown', this.onKeydown);
  },
  methods: {
    cerrar() {
      this.$emit("input", false);
      this.$emit("update:value", false);
      this.$emit("update:modelValue", false);
    },
    onKeydown(e) {
      if (e.key === "Escape" && this.visible) this.cerrar();
    }
  }
};
</script>

<style scoped>
/* ═══════════════════════════════════════════════════════
   OVERLAY — CENTRADO PERFECTO
═══════════════════════════════════════════════════════ */
.cpm-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: rgba(15, 26, 47, 0.7);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  overflow: hidden;
}

/* ═══════════════════════════════════════════════════════
   MODAL — MISMA ESTRUCTURA QUE ChatbotModal
═══════════════════════════════════════════════════════ */
.cpm-modal {
  width: 100%;
  max-width: 480px;
  height: calc(100vh - 2rem);
  height: calc(100dvh - 2rem);
  max-height: 780px;
  background: #ECE5DD;
  border-radius: 24px;
  border: 6px solid #0f1a2f;
  box-shadow:
    0 30px 80px -20px rgba(15, 26, 47, 0.7),
    0 0 0 1px rgba(255, 255, 255, 0.08) inset;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}

/* ═══════════════════════════════════════════════════════
   HEADER
═══════════════════════════════════════════════════════ */
.cpm-header {
  background: #0f1a2f;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  flex-shrink: 0;
  border-bottom: 1px solid rgba(232, 122, 48, 0.15);
}

.cpm-header-info {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
}

.cpm-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: #fff;
  display: grid;
  place-items: center;
  flex: none;
  overflow: hidden;
}
.cpm-avatar img { height: 28px; width: auto; object-fit: contain; }

.cpm-header-text { min-width: 0; }
.cpm-header-text strong {
  font-size: 0.95rem;
  font-weight: 900;
  display: block;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cpm-header-text small { font-size: 0.7rem; opacity: 0.8; }

.cpm-header-actions {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}

.cpm-icon-btn {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  border: 0;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.15s ease;
  font-size: 1.1rem;
}
.cpm-icon-btn:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: scale(1.05);
}
.cpm-icon-btn.cpm-close:hover {
  background: #ef4444;
}

/* ═══════════════════════════════════════════════════════
   BODY — Contiene el chat de consulta
═══════════════════════════════════════════════════════ */
.cpm-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

/* ═══════════════════════════════════════════════════════
   TRANSICIÓN
═══════════════════════════════════════════════════════ */
.cpm-slide-enter-active {
  transition: transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1),
              opacity 0.25s ease;
}
.cpm-slide-leave-active {
  transition: transform 0.25s ease, opacity 0.2s ease;
}
.cpm-slide-enter-from {
  opacity: 0;
  transform: translateY(30px) scale(0.95);
}
.cpm-slide-leave-to {
  opacity: 0;
  transform: translateY(20px) scale(0.98);
}

/* ═══════════════════════════════════════════════════════
   📱 MÓVIL
═══════════════════════════════════════════════════════ */
@media (max-width: 640px) {
  .cpm-overlay {
    padding: 0;
    align-items: stretch;
    justify-content: stretch;
  }

  .cpm-modal {
    max-width: 100%;
    width: 100%;
    height: 100vh;
    height: 100dvh;
    max-height: none;
    border-radius: 0;
    border: 0;
    box-shadow: none;
  }

  .cpm-header {
    padding: 10px 12px;
    padding-top: max(10px, env(safe-area-inset-top));
  }
  .cpm-avatar { width: 34px; height: 34px; }
  .cpm-avatar img { height: 24px; }
  .cpm-header-text strong { font-size: 0.88rem; }
  .cpm-header-text small { font-size: 0.65rem; }
  .cpm-icon-btn { width: 32px; height: 32px; }
}
</style>